(function ($) {
	function initMap($el) {
		let $markers = $el.find('.marker');

		// Create gerenic map.
		let mapArgs = {
			zoom: $el.data('zoom') || 16,
			mapTypeId: google.maps.MapTypeId.ROADMAP
		};
		let map = new google.maps.Map($el[0], mapArgs);

		// Add markers.
		map.markers = [];
		$markers.each(function () {
			initMarker($(this), map);
		});

		// Center map based on markers.
		centerMap(map);

		// Return map instance.
		return map;
	}

	function initMarker($marker, map) {

		// Get position from marker.
		let lat = $marker.data('lat');
		let lng = $marker.data('lng');
		let icon = $marker.data('marker');
		let latLng = {
			lat: parseFloat(lat),
			lng: parseFloat(lng)
		};

		// Create marker instance.
		let marker = new google.maps.Marker({
			position: latLng,
			map: map,
			icon: icon
		});

		// Append to reference for later use.
		map.markers.push(marker);

		// If marker contains HTML, add it to an infoWindow.
		if ($marker.html()) {

			// Create info window.
			let infowindow = new google.maps.InfoWindow({
				content: $marker.html(),
				maxWidth: 670

			});

			// Show info window when marker is clicked.
			google.maps.event.addListener(marker, 'click', function () {
				infowindow.open(map, marker);
			});
		}
	}

	function centerMap(map) {

		// Create map boundaries from all map markers.
		let bounds = new google.maps.LatLngBounds();
		map.markers.forEach(function (marker) {
			bounds.extend({
				lat: marker.position.lat(),
				lng: marker.position.lng()
			});
		});

		// Case: Single marker.
		if (map.markers.length == 1) {
			map.setCenter(bounds.getCenter());

			// Case: Multiple markers.
		} else {
			map.fitBounds(bounds);
		}
	}

	$(document).ready(function () {
		$('.acf-map').each(function () {
			let map = initMap($(this));
		});
	});

})(jQuery);
